import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { acceptKnowledgeSuggestion } from "./schema/accept-knowledge-suggestion";
import { createKnowledgeArticle } from "./schema/create-knowledge-article";
import { deleteKnowledgeArticle } from "./schema/delete-knowledge-article";
import { getDemoKnowledgeArticle } from "./schema/get-demo-knowledge-article";
import { getKnowledgeArticle } from "./schema/get-knowledge-article";
import { getKnowledgeSuggestions } from "./schema/get-knowledge-suggestions";
import { listKnowledge } from "./schema/list-knowledge";
import { rejectKnowledgeSuggestion } from "./schema/reject-knowledge-suggestion";
import { scrapeKnowledge } from "./schema/scrape-knowledge";
import { setKnowledgeArticleAvailability } from "./schema/set-knowledge-article-availability";
import { updateKnowledgeArticle } from "./schema/update-knowledge-article";
import { upsertDemoKnowledgeArticle } from "./schema/upsert-demo-knowledge-article";

export const rpcDefinition = {
  listKnowledge,
  getKnowledgeArticle,
  getKnowledgeSuggestions,
  createKnowledgeArticle,
  updateKnowledgeArticle,
  setKnowledgeArticleAvailability,
  deleteKnowledgeArticle,
  acceptKnowledgeSuggestion,
  rejectKnowledgeSuggestion,
  scrapeKnowledge,
  getDemoKnowledgeArticle,
  upsertDemoKnowledgeArticle,
};

export type RedoMerchantAgentKnowledgeRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
